export default __webpack_public_path__ + "static/media/drop.729ff642.svg";